/** Current order status groups used by the Orders quick filters. */
export const STATUS_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'pre-pickup', label: 'Pre-pickup' },
  { id: 'in-transit', label: 'In transit' },
  { id: 'delivered', label: 'Delivered' },
  { id: 'cancelled', label: 'Cancelled' },
  { id: 'other', label: 'Other' },
];

const STATUS_GROUPS = {
  QUOTE: 'pre-pickup',
  ENTRY: 'pre-pickup',
  AVAIL: 'pre-pickup',
  ASSGN: 'pre-pickup',
  DEASSGN: 'pre-pickup',
  DISP: 'in-transit',
  DISPATCHED: 'in-transit',
  IMEMPTY: 'in-transit',
  ENRTE: 'in-transit',
  ARRSHIP: 'in-transit',
  'ARRIVE SHIPPER': 'in-transit',
  DEPSHIP: 'in-transit',
  'DEPART SHIPPER': 'in-transit',
  SPOTTED: 'in-transit',
  SPTLD: 'in-transit',
  PICKD: 'in-transit',
  ARRCONS: 'in-transit',
  'ARRIVE CONSIGNEE': 'in-transit',
  DEPCONS: 'in-transit',
  'DEPART CONSIGNEE': 'in-transit',
  UNLOADING: 'in-transit',
  UNAPPRVD: 'delivered',
  DELVD: 'delivered',
  DELIVERED: 'delivered',
  COMPLETE: 'delivered',
  COMPLETED: 'delivered',
  ACC: 'delivered',
  APPRVD: 'delivered',
  BILLD: 'delivered',
  PRINTED: 'delivered',
  AUDIT: 'delivered',
  CANCL: 'cancelled',
};

export function getOrderStatusGroup(status) {
  const code = String(status ?? '').trim().toUpperCase();
  return STATUS_GROUPS[code] || 'other';
}
